<script>
  import { onMount } from 'svelte';
  import Switcher from './Switcher.svelte';
  import AnotherService from './AnotherService.svelte';
  import session from '../lib/session';
  import { fade } from 'svelte/transition';

  // component options  ------------------------------------------------------ //

  export let route_name;
  export let query;

  // internal variables ------------------------------------------------------ //

  let is_in_register = false;
  let list_items = [];
  let token;
  let partner;
  let merchant_uuid = 0;

  const init_switcher_for_invitation = () => {
    token = query.token;
    partner = query.partner ? query.partner : '?';
    merchant_uuid = query.merchant;

    let item = {
      token: token,
      merchant_uuid: query.merchant,
      active: false,
    };

    list_items = [item];
  };

  const init_switcher = async is_in_reg => {
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });
    if (query && 'token' in query) {
      is_in_reg = true;
      is_in_register = true;
      init_switcher_for_invitation();
    }

    if (is_in_reg === false) {
      list_items = $session.user.registered_merchants.map(m => {
        return {
          name: m.selection_name,
          merchant_uuid: m.uuid,
          active: m.uuid === $session.merchant.merchant_uuid,
          status: m.status,
          country: m.country,
          multi_country: m.multi_country,
        };
      });
      list_items.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    }
  };

  onMount(() => {
    init_switcher(is_in_register);
  });

  $: if (!is_in_register && $session.user) {
    list_items = $session.user.registered_merchants.map(m => {
      return {
        name: m.selection_name,
        merchant_uuid: m.uuid,
        active: m.uuid === $session.merchant.merchant_uuid,
        status: m.status,
        country: m.country,
        multi_country: m.multi_country,
      };
    });
    list_items.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
  }
</script>

  <main class="main--global wrapper fade-in">
  {#if is_in_register === false}
    <div transition:fade={{ duration: 100 }}>
      <Switcher
        {init_switcher}
        bind:list_items
        bind:page_state={is_in_register} />
    </div>

  {:else}
    <div transition:fade={{ duration: 100 }}>
    <AnotherService
      bind:page_state={is_in_register}
      invite_token={token}
      invite_partner={partner}
      {merchant_uuid} />
    </div>
  {/if}

</main>

<style type="text/scss">
  .btn-yes,
  btn-yes:hover {
    background-color: var(--worker-background-color);
    color: var(--worker-foreground-color);
  }

  .actionContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
    margin-right: 20px;
  }

  .service-label {
    color: dimgray;
    font-size: 90%;
    text-align: center;
    margin-top: 1px;
  }

  /* Desktop Mode
   *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 600px; /* todo: finalise */
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 70%; /* todo: finalise */
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }
  }
</style>
